import request from '@/interceptor/request';
import qs from 'qs';

const post = (url, data, ...options) =>
  request.post(url, qs.stringify(data), ...options);
const upload = (url, data, ...options) => request.post(url, data, ...options);
export { post, upload };